import { motion } from 'framer-motion'
export const AnimationOpacity = ({ children, className, amount, duration }) => {
    return (
        <motion.div
            initial={{
                opacity: 0.1,
            }}
            whileInView={{
                opacity: 1,
                transition: {
                    duration: duration,
                    ease: 'easeInOut',
                    // delay: { delay },
                },
            }}
            viewport={{ once: false, amount: amount }}
            // viewport={{ once: false, amount: 0.8 }}
            className={`${className}`}
        >
            {children}
        </motion.div>
    )
}
